import { isArray, randId } from '@/common/js/utils'
import { getRecmWordPackages } from '@/api/baidu.model'
export default {
  data () {
    return {

      mult_app: [], // 已选的app数据

      wordLoading: null,
      wordMaxTotal: 1000,
      wordCurrent: '',
      wordResponse: null,
      wordData: [],
      addWordColumns: [
        {
          title: '意图词包名',
          key: 'packageName'
        },
        {
          title: '人群覆盖率',
          key: 'estimate',
          sortable: true,
          render: (h, params) => {
            const num = params.row.estimate * 100
            return h('span', `${num.toFixed(2)}%`)
          }
        }
      ]
    }
  },
  methods: {
    clearAppData () {
      this.clearSearchData()
      this.mult_app = []
    },
    clearSearchData () {

    },
    searchAppData ({ keyword, page }) {

    },
    appendMultApp (row) {

    },
    delMultApp (row) {

    },
    searchWordData ({ keyword }) {
      this.wordLoading = true
      this.wordResponse = false
      getRecmWordPackages({
        ad_account_id: this.account,
        query: keyword
      }).then(data => {
        this.wordLoading = false
        if (data && isArray(data) && data.length) {
          this.wordData = data.map((ret, id) => {
            ret.id = randId(id)
            ret.keyWords = ret.keyWords.map((t, i) => {
              const index = this.mult_word.findIndex(met => met.name === t.name)
              const check = index > -1
              return { id: parseInt(`${ret.id}${i}`), value: t, name: t, check }
            })
            return ret
          })
          this.wordCurrent = this.wordData[0].id
        } else {
          this.wordResponse = true
          this.wordData = []
        }
      })
    },
    // 全选
    appendMultWord ({ current, check }) {
      if (current) this.controlWord(current, !!check)
    },
    clearWordData () {
      this.res_word = []
      this.wordData.forEach(ret => {
        this.controlWord(ret.id, false)
      })
    },
    delMultWord (name) {
      const current = this.getParent(name)
      if (current) {
        const { keyWords } = current
        const index = keyWords.findIndex(ret => ret.id === name)
        if (index > -1) this.$set(keyWords[index], 'check', false)
      } else {
        const index = this.res_word.findIndex(ret => ret.id === name)
        this.res_word.splice(index, 1)
      }
    },
    addMultWord (tags) {
      const addTagger = tags.map((ret, id) => {
        return { id: randId(id), value: ret, name: ret }
      })
      this.res_word.push(...addTagger)
    },
    // 查找父类
    getParent (name) {
      let parent
      for (const ret of this.wordData) {
        const cool = ret.keyWords.map(met => met.id).includes(name)
        if (cool) {
          parent = ret
          break
        }
      }
      return parent
    },
    // 操作子集
    controlWord (id, check) {
      const index = this.wordData.findIndex(ret => ret.id === id)
      if (index > -1) {
        this.wordData[index].keyWords.forEach(ret => {
          this.$set(ret, 'check', check)
        })
      }
    }
  },
  watch: {
    wordCurrent (nVal) {
      const index = this.wordData.findIndex(ret => ret.id === nVal)
      this.wordData.forEach(ret => {
        this.$set(ret, '_highlight', false)
      })
      if (index > -1) this.$set(this.wordData[index], '_highlight', true)
    }
  }
}
